import { render } from "./CFormInput.vue?vue&type=template&id=154c0d15&scoped=true"
import script from "./CFormInput.vue?vue&type=script&lang=js"
export * from "./CFormInput.vue?vue&type=script&lang=js"

import "./CFormInput.vue?vue&type=style&index=0&id=154c0d15&lang=scss&scoped=true"

import exportComponent from "/builds/advocacy/e-advokat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154c0d15"]])

export default __exports__